import { render, staticRenderFns } from "./internet.vue?vue&type=template&id=5b00572f&scoped=true&"
import script from "./internet.vue?vue&type=script&lang=js&"
export * from "./internet.vue?vue&type=script&lang=js&"
import style0 from "./internet.vue?vue&type=style&index=0&id=5b00572f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00572f",
  null
  
)

export default component.exports